module.exports = __webpack_public_path__ + "../resources/img/ic_columns_cyanblue.a63480d1.svg";